<div class="error-state">
  <button class="error-icon" (click)="handleRetry()" [attr.aria-label]="retryButtonText()">
    <ng-icon name="iconoirRefresh" [size]="iconSize().toString()"></ng-icon>
  </button>
  <p class="error-message">{{ message() }}</p>
</div>
